import Bloc from './Bloc.js';
import Types from './Types.js';

export default class DeckSize extends Bloc {

	constructor (src, ctx) {

		super("decksize", src, ctx);
		this.f = (src, ins) => [src.master.run.deckSize];
		this.types = [];
	}
}